import { funlidayRequest } from './main';

/** postSystemLog - 紀錄 client log
 * @param {String} tag (Required)當成 keyword 由 client 自行決定要塞入什麼字串當成 keyword 分類
 * @param {String} message (Required)欲紀錄的錯誤訊息
 * @param {String} level (Required)此 log 的種類，可帶入 "info" 、 "debug" 、 "warn" 、 "error"  四種字串其中一中
 * @returns {Promise} axiosPromise
 */
export const postSystemLog = (tag, message, level = 'error') => {
  const params = { tag, message, level };
  return funlidayRequest.post(`postLog`, params);
};
